/*
 * Merch product page behaviour:
 *  - "Vous aimerez aussi" carousel (prev/next arrows + scroll-snap).
 *  - Colour / size selection lives in assets/0-variant-options.js.
 * Add-to-cart / cart drawer are handled by Horizon's <product-form-component>.
 */
(function () {
  /* ---------- Recommendations carousel ---------- */
  function initCarousel(root) {
    var track = root.querySelector('.mrec__track');
    var prev = root.querySelector('.mrec__arrow--prev');
    var next = root.querySelector('.mrec__arrow--next');
    if (!track) return;

    function step() {
      var card = track.querySelector('.mrec__card');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      if (!prev || !next) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 2;
      prev.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    document.querySelectorAll('.mrec').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
